import React, { memo } from 'react';
import classNames from 'classnames';
import { FormConsumer } from '@active/react-ui/Form';
import { TwoColsField } from '../AddressEditor';

const ContactField = ({
  name, field, isStatic,
}) => {
  const isTwoColsField = name === 'firstName' || name === 'lastName';

  if (isStatic) {
    return <FormConsumer>
      {
        ({
          form: { values },
        }) => {
          const classes = classNames({
            'billing-contact__static-field': true,
            'billing-contact-oneline': isTwoColsField,
          });

          return <div className={classes}>{values[name]}</div>;
        }
      }
    </FormConsumer>;
  }
  return <TwoColsField field={field} isTwoColsField={isTwoColsField}/>;
};

export default memo(ContactField);
